import styled from 'styled-components'
import { Button } from 'ui/components/Buttons'
import { Link } from 'ui/components/Link'

export const SaveButton = styled(Button)`
  align-self: flex-start;
`

export const WrappedLink = styled(Link)`
  a {
    font-size: 14px;
  }
` as typeof Link
